module.exports = __webpack_public_path__ + "static/media/LandingPageLogo.b04b44ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/LandingPageLogo.png
// module id = 250
// module chunks = 0